export default {
  get: function(){
    return{
      contentMessageStatus: true
    }
  }
}
